// extracted by mini-css-extract-plugin
export default {"cancelNotification":"wL6jFX","insideModal":"cRNJST","noTopMargin":"L0nOJi","canceledIcon":"wqGGqs"};